import { Project, ProjectModel } from 'src/store/state/projects';

export const getProjectTargetModel = (
  project: Pick<Project, 'modelsById' | 'targetModelId'>
): ProjectModel => {
  return project.modelsById[project.targetModelId];
};
